import type { SVGIcon } from '@constants/icons'

export const LinkArrowIcon: SVGIcon = props => (
  <svg viewBox='0 0 32 32' aria-hidden='true' focusable='false' {...props}>
    <path
      d='M22 11L10.5 22.5M10.44 11H22v11.56'
      fill='none'
      strokeWidth='2'
      stroke='currentcolor'
    />
  </svg>
)
